/**
 * LOCAL STORAGE KEYS
 */
export enum LocalStorageKeys {
  COLUMN_STATE_KEY = 'COLUMN_STATE',
  CC_COLUMN_STATE_KEY ='CC_COLUMN_STATE',
  FILTER_STATE_KEY = 'FILTER_STATE',
  LOCATIONS_CONTAINER_DIMENSIONS_KEY = 'LOCATIONS_CONTAINER_DIMENSIONS',
  COLUMN_NOTES_SNACKBAR_KEY = 'COLUMN_NOTES_SNACKBAR',
  LANGUAGE = 'LANGUAGE',
  NAVIGATION = 'NAVIGATION',
  GX_WRAPPED = 'GX_WRAPPED',
  CAMPAIGNS_STATE = 'CAMPAIGNS_STATE',
  AI_INSIGHTS_STATE = 'AI_INSIGHTS_STATE',
  REVIEWS_STATE = 'REVIEW_STATE'
}
